// Global Types
import type {
  $Translate,
} from 'common.language';
import type {
  $Model,
  $ModelUpsertParams,
} from 'common.data';

// Global Components
import * as React from 'react';
import {
  Col,
  Row,
} from 'reactstrap';
import {
  AvField,
} from 'availity-reactstrap-validation';
import {
  InputFile,
} from '@vroskus/library-components';

// Helpers
import _ from 'lodash';
import ErrorLog from '@vroskus/library-sentry/dist/browser';
import config from '../../../config';

// Components
import InputNo from '../../form/InputNo';

// Types
import type {
  $ReducerState,
} from '../../../redux';

export type $OwnProps = $Translate & {
  item: $Model<'Entry'> | $ModelUpsertParams<'Entry'>;
};

export type $StateProps = {
  main: $ReducerState<'main'>;
};

export type $DispatchProps = Record<string, unknown>;

type $Props = $DispatchProps & $OwnProps & $StateProps;

const EntryFieldsView = function ({
  item,
  main,
  t,
}: $Props) {
  return (
    <>
      <Row>
        <Col>
          <AvField
            label={t('Title')}
            name={'Name'}
            required
            value={item.Name}
          />
        </Col>
        <Col>
          <InputFile
            fileDirUrl={`${config.CDN_URL}/images/max`}
            imageThumbDirUrl={`${config.CDN_URL}/images/min`}
            label={t('Image')}
            labelChangeFile={t('Change file')}
            labelError={t('Error')}
            labelFile={t('File')}
            name={'Image'}
            onError={ErrorLog.exception}
            uploadUrl={`${config.CDN_URL}/v1.0/upload/image`}
            value={item.Image}
          />
        </Col>
      </Row>
      <Row>
        <Col>
          <InputNo
            disabled={!!item.id}
            label={t('Registration no.')}
            name={'RegistrationNo'}
            required
            value={item.RegistrationNo}
          />
        </Col>
        <Col>
          <InputNo
            label={t('Sail no.')}
            name={'SailNo'}
            value={item.SailNo}
          />
        </Col>
      </Row>
      <Row>
        <Col>
          <AvField
            label={t('Make / Model')}
            name={'Model'}
            value={item.Model}
          />
        </Col>
        <Col>
          <AvField
            label={t('Harbor')}
            name={'Harbor'}
            value={item.Harbor}
          />
        </Col>
        <Col>
          <AvField
            label={t('Club')}
            name={'Club'}
            value={item.Club}
          />
        </Col>
      </Row>
      <Row>
        <Col>
          <AvField
            label={t('Region')}
            name={'RegionId'}
            required
            type={'select'}
            value={item.RegionId}
          >
            {_.map(
              main.regions,
              (i) => (
                <option
                  key={i.id}
                  value={i.id}
                >
                  {i.Name}
                </option>
              ),
            )}
          </AvField>
        </Col>
      </Row>
    </>
  );
};

export default EntryFieldsView;
